<!-- eslint-disable vue/no-parsing-error -->
<template>
    <div>
        <v-tabs v-model="tab" dark class="rounded-lg" dense background-color="primary" active-class="tab-active"
            slider-color="#ffbc00">
            <v-tab class="font-weight-black">PAGOS</v-tab>
            <v-tab class="font-weight-black">DÉBITO
                </br>AUTOMÁTICO DEL BANCO
            </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
            <v-tab-item>
                <pagosComp class="mt-2"></pagosComp>
            </v-tab-item>
            <v-tab-item>
                <debitoAutomaticoComp class="mt-2"></debitoAutomaticoComp>
            </v-tab-item>
        </v-tabs-items>
    </div>
</template>

<style>
.btn_block_style3 {
    background-color: #E53935 !important;
}

.btn_block_style4 {
    background-color: #4caf50 !important;
}

.btn_pago_efectivo {
    background-color: #ffee00 !important;
}

.v-data-table__checkbox {
    text-align: center !important;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
    background: var(--v-secondary-base) !important
}

.theme--dark.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
    background: var(--v-secondary-base) !important
}

.btn_block_green {
    background-color: green !important;
}

.btn_block_red {
    background-color: red !important;
}
</style>

<script>

import PagosComp from './components/PagosComp.vue'
import DebitoAutomaticoComp from './components/DebitoAutomaticoComp.vue'

export default {
    data() {
        return {
            tab: 0
        }
    },
    components: {
        pagosComp: PagosComp,
        debitoAutomaticoComp: DebitoAutomaticoComp
    },
}

</script>